const files = import.meta.glob(['./modules/*.js', '!./modules/*.{test,spec}.js'], { eager: true });

const modules = {};
for (const key in files) {
  const name = key.replace(/\.\/modules\/|\.js/g, '');
  const module = { ...files[key] };
  if (module.namespaced === undefined) {
    module.namespaced = true;
  }
  modules[name] = module;
}
export default modules;
